export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/api/auth/login',
    REFRESH: '/api/auth/refresh',
    LOGOUT: '/api/auth/logout',
    PROFILE: '/api/auth/profile',
    CHANGE_PASSWORD: '/api/auth/password',
    SESSIONS: '/api/auth/sessions',
    CHECK: '/api/auth/check'
  },
  USERS: {
    LIST: '/api/users',
    DETAIL: '/api/users/:id',
    UPDATE: '/api/users/:id',
    DELETE: '/api/users/:id',
    SUSPEND: '/api/users/:id/suspend'
  },
  EMERGENCY: {
    LIST: '/api/emergency',
    DETAIL: '/api/emergency/:id',
    RESPOND: '/api/emergency/:id/respond',
    CLOSE: '/api/emergency/:id/close'
  },
  OTP: {
    LIST: '/api/otp',
    STATS: '/api/otp/stats'
  },
  MESSAGING: {
    LIST: '/api/messaging',
    MODERATE: '/api/messaging/:id/moderate'
  },
  ANALYTICS: {
    DASHBOARD: '/api/analytics/dashboard',
    USERS: '/api/analytics/users',
    EMERGENCY: '/api/analytics/emergency',
    EXPORT: '/api/analytics/export'
  },
  AI: {
    THREAT_ANALYSIS: '/api/v1/analyze/threat',
    BEHAVIOR_ANALYSIS: '/api/v1/analyze/behavior',
    HEALTH: '/health',
    METRICS: '/metrics',
    TRAINING_FEEDBACK: '/api/v1/training/feedback',
    TRAINING_STATUS: '/api/v1/training/status',
    TRAINING_MODELS: '/api/v1/training/models',
    LEARNING_SOURCES: '/api/v1/learning/sources'
  }
} as const;

export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'gmh_admin_token',
  REFRESH_TOKEN: 'gmh_admin_refresh',
  USER_DATA: 'gmh_admin_user',
  PREFERENCES: 'gmh_admin_prefs',
  THEME: 'gmh_admin_theme'
} as const;

export const SOCKET_EVENTS = {
  CONNECT: 'connect',
  DISCONNECT: 'disconnect',
  AUTHENTICATE: 'authenticate',
  AUTHENTICATED: 'authenticated',
  USER_ACTIVITY: 'user_activity',
  EMERGENCY_ALERT: 'emergency_alert',
  NEW_MESSAGE: 'new_message',
  OTP_REQUEST: 'otp_request',
  SYSTEM_ALERT: 'system_alert'
} as const;

export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  UNPROCESSABLE_ENTITY: 422,
  TOO_MANY_REQUESTS: 429,
  INTERNAL_SERVER_ERROR: 500
} as const;
